import api from "@/services/api";

/****************
 * Roles
 ****************/

export default {
  /**
   * Haal alle rollen op
   */
  getRoles() {
    return api.get("/api/v1/roles");
  },

  /**
   * Haal één rol op (inclusief permissies)
   * @param {Number} roleId
   */
  getRole(roleId) {
    return api.get("/api/v1/role", { params: { id: roleId } });
  },

  /**
   * Maak een nieuwe rol aan
   */
  createRole(data) {
    return api.post("/api/v1/roles", data);
  },

  /**
   * Update een bestaande rol
   */
  updateRole(roleId, data) {
    return api.put("/api/v1/role", { id: roleId, ...data });
  },

  /**
   * Verwijder een rol
   */
  deleteRole(roleId) {
    return api.delete("/api/v1/role", { params: { id: roleId } });
  },

  /**
   * ⬇️ PERMISSIONS ⬇️
   */

  /**
   * Haal permissions op (optioneel per rol)
   */
  getPermissions(roleId) {
    return api.get("/api/v1/role/permissions", {
      params: roleId ? { role_id: roleId } : {}
    });
  },

  /**
   * Haal één specifieke permission op
   */
  getPermission(permissionId) {
    return api.get("/api/v1/role/permission", {
      params: { id: permissionId }
    });
  },

  /**
   * Ken meerdere permissions toe aan een rol (batch opslaan)
   * → Één enkele POST naar de nieuwe bulk‐endpoint
   *
   * @param {Number} roleId
   * @param {Array<Object>} permissionsArray  Array van objects:
   *    [{ collection_id, field, title, permissions: { create, read, update, delete, owner } }, …]
   */
  assignPermissions(roleId, permissionsArray) {
    // In plaats van Promise.all, sturen we precies één POST:
    return api.post("/api/v1/role/permissions/bulk", {
      role_id: roleId,
      permissions: permissionsArray
    });
  },

  /**
   * Update 1 permission
   */
  updatePermission(permissionId, data) {
    return api.put("/api/v1/role/permission", {
      id: permissionId,
      ...data
    });
  },

  /**
   * Verwijder 1 permission
   */
  deletePermission(permissionId) {
    return api.delete("/api/v1/role/permission", {
      params: { id: permissionId }
    });
  }
};
